import _Vue, { PluginFunction, PluginObject } from 'vue';

import ColorPicker from './ColorPicker.vue';

export function ColorPickerPlugin(Vue: typeof _Vue, options?: {}) {
  Vue.component('color-picker', ColorPicker);
}
